import { Rol } from './rol.model';

export class Profile {
  userName: string;
  profile: any;

  /**
   * Constructor
   *
   * @param profile
   */
  constructor(profile) {
    this.userName = profile.userName || '';
    this.profile = profile.profile || '';
  }
}